import React from 'react';
import { TextField } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { ValidatorComponent } from "react-material-ui-form-validator";
import Autocomplete from '@mui/material/Autocomplete';

class TextFieldValidator extends ValidatorComponent  {
    constructor(props) {
        super(props);
        this.state = {};
      }
        renderValidatorComponent(){

            const { isValid } = this.state;
            
            const updateSelected = (event, value)=> {
                this.props.handleSelectChange(value)
            }

            
            
            return (
                <>
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={this.props.states}
                    value={this.props.value}
                    // name={this.props.name}
                    onChange={updateSelected}
                    validators={['required']}
                    // error={(isValid===false)}
                    // fullWidth
                    // required
                    renderInput={(params) => <TextField {...params} 
                                                        name={this.props.name} 
                                                        label={this.props.label} 
                                                        variant="standard" 
                                                        value={this.props.value} 
                                                        error={(isValid===false)} 
                                                        validators={['required']} 
                                                        fullWidth 
                                                        required  />}
                    
                />
                </>
            )
        }
    
}

export default withTranslation()(TextFieldValidator)